import { render, staticRenderFns } from "./SettingsSearch.vue?vue&type=template&id=3d83a0e9"
import script from "./SettingsSearch.vue?vue&type=script&lang=js"
export * from "./SettingsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports